export default __webpack_public_path__ + "static/media/signin.163f748e.jpg";